import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import SessionCard from '../components/SessionCard';
import './Sessions.css';

export default function Sessions({ onSelect }) {
  const { user, sessions, favorites, progress } = useApp();
  const [filter, setFilter] = useState('all'); // all | favorites | listened

  const sorted = [...sessions].sort((a, b) =>
    new Date(a.classDate) - new Date(b.classDate)
  );

  const filtered = sorted.filter(s => {
    if (filter === 'favorites') return favorites[s.id];
    if (filter === 'listened')  return (progress[s.id]?.pct || 0) >= 80;
    return true;
  });

  return (
    <div className="sessions-screen">
      <div className="sessions-header">
        <div className="sessions-eyebrow">Bienestar · Movimiento</div>
        <h1 className="sessions-title">Gimnasia<br />Consciente</h1>
        <p className="sessions-author">por María Rosa Poggi</p>
        <div className="sessions-line" />
      </div>

      <div className="sessions-filters">
        <button
          className={`filter-pill ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          Todas
        </button>
        <button
          className={`filter-pill ${filter === 'favorites' ? 'active' : ''}`}
          onClick={() => setFilter('favorites')}
        >
          ♥ Favoritas
        </button>
        <button
          className={`filter-pill ${filter === 'listened' ? 'active' : ''}`}
          onClick={() => setFilter('listened')}
        >
          ✓ Escuchadas
        </button>
      </div>

      <div className="sessions-count">
        {filtered.length} {filtered.length === 1 ? 'sesión' : 'sesiones'}
      </div>

      <div className="sessions-list">
        {filtered.length === 0 ? (
          <div className="sessions-empty">
            No hay sesiones en esta categoría.
          </div>
        ) : (
          filtered.map(session => (
            <SessionCard
              key={session.id}
              session={session}
              progress={progress[session.id]?.pct || 0}
              listened={(progress[session.id]?.pct || 0) >= 80}
              favorite={!!favorites[session.id]}
              onClick={() => onSelect(session)}
            />
          ))
        )}
      </div>
    </div>
  );
}
